// eslint-disable-next-line import/no-extraneous-dependencies
import { checkboxAnatomy } from '@chakra-ui/anatomy';
import type { ComponentStyleConfig } from '@chakra-ui/react';
import type { StyleFunctionProps } from '@chakra-ui/theme-tools';

export const Checkbox: ComponentStyleConfig = {
  parts: [...checkboxAnatomy.keys],
  baseStyle: (props: StyleFunctionProps) => ({
    control: {
      borderColor: 'mGray.100',
      borderRadius: 'base',
      boxShadow: 'xs',
      _focus: {
        boxShadow: 'outlineXs',
      },
    },
  }),
  defaultProps: {
    colorScheme: 'mGray',
  },
};
